<template>
  <f7-page
    @page:beforein="beforein"
  >
    <navbar>
      <template
        v-slot:nav-title
        class="breadcrumbs"
      >
        <span
          class="breadcrumb-link"
          @click="$f7.views.main.router.navigate('/cockpit/', { reloadCurrent: true })"
        >
          {{ $t('Home_navbar_title') }}
        </span>
        <f7-icon class="icon-breadcrumb" />
        <span class="breadcrumb-title">{{ changeTitle }}</span>
      </template>
    </navbar>
    <div v-if="selection === 'GreenHouse'">
      <GreenHousePartTwo
        :list-irrigation-gh="irrigation"
        :list-manure-gh="manure"
      />
    </div>
    <div v-else>
      <OpenAirPartTwo />
    </div>
    <f7-block-footer
      class="content-action-botton"
    >
      <f7-button
        :class="`dx-btn-cancel margin-right color-${selection}`"
        raised
        type="default"
        text-color="grey"
        styling-mode="outlined"
        name="ButtonCancel"
        @click="goToBackPage"
      >
        {{ $t('button_back') }}
      </f7-button>
      <f7-button
        v-if="selection === 'GreenHouse'"
        class="dx-btn-success color-orange"
        raised
        type="success"
        styling-mode="contained"
        name="ButtonSave"
        @click="saveProject"
      >
        {{ $t("execute") }}
      </f7-button>
      <f7-button
        v-else
        class="dx-btn-success open-air"
        raised
        type="success"
        styling-mode="contained"
        name="ButtonSave"
        @click="saveProjectOpenAir"
      >
        {{ $t("execute") }}
      </f7-button>
    </f7-block-footer>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import GreenHousePartTwo from '../../components/registerProject/registerProjectGreenhouse/GreenHosePartTwo/index.vue';
import OpenAirPartTwo from '../../components/registerProject/registerProjectOpenAir/OpenAirPartTwo/index.vue';
import navbar from '../../components/navbar/NavBar.vue';

export default {
  name: 'PageTwoRegisterProject',
  components: {
    GreenHousePartTwo,
    OpenAirPartTwo,
    navbar,
  },
  data() {
    return {
    };
  },
  computed: {
    changeTitle() {
      if (this.keyName === '/openProject/') {
        return this.$t('editProject_title');
      } if (this.newProjectOpenAir.id || this.newProject.id) {
        return 'EDITAR PROYECTO';
      }
      return this.$t('LeftPanel_title_newProject');
    },
    ...mapState('authentication', ['selection']),
    ...mapState('ProjectGreenHouse', ['manure', 'irrigation', 'newProject']),
    ...mapState('ProjectOpenAir', { newProjectOpenAir: (state) => state.newProject }),
    ...mapState('Database', ['listIrrigationGh', 'listManureGh', 'currentProject']),
  },
  methods: {
    async beforein() {
      this.$f7.preloader.show();
      try {
        await this.fetchListIrrigation();
        const a1 = [{ name: 'Añadir', id: 1 }];
        let arrayConcat = a1.concat(this.listIrrigationGh);
        this.setIrrigationConcated(arrayConcat);
        await this.fetchListManure();
        arrayConcat = a1.concat(this.listManureGh);
        this.setManureConcated(arrayConcat);
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    goToBackPage() {
      this.$f7.views.main.router.navigate('/pageRegisterProject/', { reloadCurrent: false });
      this.setCont(1);
    },
    async saveProject() {
      this.$f7.preloader.show();
      try {
        if (this.newProject.id) {
          if (this.newProject.originalName === this.newProject.name
              && this.currentProject !== '6266cb565842a56069a46607') {
            await this.$f7.dialog.confirm(
              'Se sobreescribirá el proyecto actual y se recalcularán los resultados.',
              async () => {
                try {
                  await this.updateProject();
                  this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
                } catch (error) {
                  this.$f7.dialog.alert(this.$t(`${error}`));
                }
              },
            );
          } else {
            await this.$f7.dialog.confirm(
              `Se creará un nuevo proyecto con el nombre de "${this.newProject.name}".`,
              async () => {
                try {
                  await this.createNewProject();
                  this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
                } catch (error) {
                  this.$f7.dialog.alert(this.$t(`${error}`));
                }
              },
            );
          }
        } else {
          await this.createNewProject();
          this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    async saveProjectOpenAir() {
      this.$f7.preloader.show();
      try {
        if (this.newProjectOpenAir.id) {
          if (this.newProjectOpenAir.originalName === this.newProjectOpenAir.name
              && this.currentProject !== '626964f0226c811a55568262') {
            await this.$f7.dialog.confirm(
              'Se sobreescribirá el proyecto actual y se recalcularán los resultados.',
              async () => {
                try {
                  await this.updateProjectOpenAir();
                  this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
                } catch (error) {
                  this.$f7.dialog.alert(this.$t(`${error}`));
                }
              },
            );
          } else {
            await this.$f7.dialog.confirm(
              `Se creará un nuevo proyecto con el nombre de "${this.newProjectOpenAir.name}".`,
              async () => {
                try {
                  await this.createNewProjectOpenAir();
                  this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
                } catch (error) {
                  this.$f7.dialog.alert(this.$t(`${error}`));
                }
              },
            );
          }
        } else {
          await this.createNewProjectOpenAir();
          this.$f7.views.main.router.navigate('/openProject/', { reloadCurrent: false });
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    ...mapActions('ProjectOpenAir', ['resetNewProjectOpenAir', 'updateProjectOpenAir', 'createNewProjectOpenAir']),
    ...mapActions('ProjectGreenHouse', ['resetNewProject', 'setIrrigationConcated', 'setManureConcated',
      'createNewProject', 'setCont', 'updateProject']),
    ...mapActions('Database', ['fetchListIrrigation', 'fetchListManure']),
  },
};
</script>

<style>
</style>
